import { render, staticRenderFns } from "./model-document-uploader-dialog.component.vue?vue&type=template&id=72b725aa"
import script from "./model-document-uploader-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./model-document-uploader-dialog.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b725aa')) {
      api.createRecord('72b725aa', component.options)
    } else {
      api.reload('72b725aa', component.options)
    }
    module.hot.accept("./model-document-uploader-dialog.component.vue?vue&type=template&id=72b725aa", function () {
      api.rerender('72b725aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/T3d-model-documents/model-document-uploader-dialog/model-document-uploader-dialog.component.vue"
export default component.exports